// extracted by mini-css-extract-plugin
module.exports = {"link":"_3q0YD","container":"_1DTji","contentPreview":"_2TcXY","image":"sz59r","contentBlock":"_1Cw21","title":"ScDlD","numbersSeparator":"_1b4Br","moreButton":"_2-w6v"};